export default __webpack_public_path__ + "static/media/Pubg.9a6fabbe.mp4";